<template>
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
      <b-col cols="12">
        <div style="margin-bottom:10px"></div>

        <div style="margin: 10px"></div>
        <b-card bg-variant="light" style="min-height: 60vh;">
          <div class="col-md-12">
            <div class="overflow-auto">
              <b-table stacked="md" id="my-table" striped small :fields="fields" :items="blocos" responsive="sm">
                <template  v-slot:cell(codigo)="data">
                  <span>{{data.item.idBloco}}</span>
                </template>
                <template v-slot:cell(status)="data">
                  <span>{{ data.item.status === 'A' ? 'Ativo' : 'Inativo' }}</span>
                </template>
                <template  v-slot:cell(visualizar)="data">
                  <b-button @click="visualizar(data.item.idBloco)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px;"><b-icon icon="search"></b-icon></b-button>
                  <b-button @click="remover(data.item.idBloco)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>
                </template>
              </b-table>
              <div style="float: right">
              </div>
            </div>
          </div>
        </b-card>
        <br>
        <b-card bg-variant="light">
          <div class="row" style="float: right">
            <b-button v-b-modal.modal-bloco style="margin-right: 30px; background-color: #303f9f">
              <b-icon icon="file-earmark"></b-icon>  Novo
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-bloco" ref="modal" title="Bloco" @hidden="resetModal" @ok="salvar" >
      <b-form-group label="Descrição" label-for="name-input"  >
        <b-input id="name-input" v-model="bloco.descricao" ></b-input>
      </b-form-group>
      <b-form-group label="Status" label-for="status-input">
        <b-select id="status-input" v-model="bloco.status" :options="statusOptions"></b-select>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },

  data(){
    return{
      blocos: [],
      fields: ['descricao', 'status', { key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      bloco: {idBloco: null, descricao: '', status: 'A'},
      statusOptions: [
        { value: 'A', text: 'Ativo' },
        { value: 'I', text: 'Inativo' }
      ]
    }
  },


  created(){
      this.validaAcesso();
  },

  mounted(){
    this.listar();
  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    resetModal() {
        this.bloco= {idBloco: null, descricao: '', status: 'A'}
    },

    salvar(){
        this.$http.post('/bloco', this.bloco).then(res => {
             this.alertaMensager(res.data,"","success");
             this.listar();
          })
    },

    validaAcesso(){
        this.$http.get('/gerencia', this.sala).then()
    },

    listar(){
      this.$http.get("/bloco").then(res => {
         this.blocos = res.data;
      })
    },

    visualizar(id){
      this.$http.get("/bloco/"+id).then(res => {
         this.bloco = res.data;
         this.$bvModal.show('modal-bloco');
      })
    },
    remover(id){
        this.$confirm("Tem certeza que deseja excluir o bloco ?").then(() => {
            this.$http.delete("/bloco/"+id).then(res => {
                if(res.status == 200){
                    this.alertaMensager("",res.data,"success");
                }else{
                    this.alertaMensager("",res.data,"error");
                }

            })
        });

    }

  }
}

</script>

<style>

</style>
